import { Component, h, Prop, Element } from '@stencil/core';
import { UniversalNavLink } from './aafp-universal-nav.types';
import { parseJSON } from '../../component-utils/jsonUtils';
import { showFoundationStyles } from '../../component-utils/stencilUtils';

@Component({
  tag: 'aafp-universal-nav',
  shadow: false,
})
export class AafpUniversalNav {
  @Prop({ mutable: true }) brandList: string = '[]';
  @Prop({ mutable: true }) bookmarkIconLink: string = '';
  @Prop({ mutable: true }) bookmarkIconLabel: string = '';
  @Prop({ mutable: true }) accountIconLink: string = '';
  @Prop({ mutable: true }) accountIconLabel: string = '';
  @Prop({ mutable: true }) cartIconLink: string = '';
  @Prop({ mutable: true }) cartIconLabel: string = '';
  @Prop({ mutable: true }) activeDesktopTitle: string = '';
  @Element() element: HTMLElement;
  ACTIVE_TITLE_CLASS: string = 'adl-universal-nav__link--active';

  /**
   *
   * @param currentlySelected
   */
  isCurrentlySelected(currentlySelected: boolean): string {
    if (currentlySelected) {
      return this.ACTIVE_TITLE_CLASS;
    }
    return '';
  }

  updateIconList(div: HTMLElement) {
    if (showFoundationStyles(document)) {
      this.element.querySelector('aafp-signin')!.remove();
      this.element.querySelector('aafp-shopping-cart')!.remove();
      div.classList.add('adl-universal-nav__icon-list--hide');
      this.element.classList.add('adl-universal-nav__max-height');
    }
  }

  render() {
    const parsedBrandList = parseJSON(this.brandList) as UniversalNavLink[];
    const parsedIsArray = Array.isArray(parsedBrandList);
    const brandList: UniversalNavLink[] = parsedIsArray ? parsedBrandList : [];
    return (
      <nav class="adl-universal-nav">
        <ul class="adl-universal-nav__brand-list">
          {brandList.map((brand) => (
            <li class="adl-universal-nav__brand-list-item" key={brand.text}>
              <a
                class={`adl-universal-nav__link adl-layout__md-hide ${this.isCurrentlySelected(
                  brand.currentlySelected,
                )}`}
                aria-label={brand.text}
                href={brand.link}
              >
                {`${brand.text}`}
              </a>
              <a
                class={`adl-universal-nav__link adl-layout__lg-hide ${this.isCurrentlySelected(
                  brand.currentlySelected,
                )}`}
                aria-label={brand.text}
                href={brand.link}
              >
                {`${brand.mobileText}`}
              </a>
            </li>
          ))}
        </ul>
        <div
          class="adl-universal-nav__icon-list"
          ref={(el: HTMLElement | undefined) => this.updateIconList(el as HTMLElement)}
        >
          <slot name="shopping-cart"></slot>
          <slot name="account-icon"></slot>
        </div>
      </nav>
    );
  }
}
